module.exports = __webpack_public_path__ + "static/img/shengyu.6548f08e.png";